import { render, staticRenderFns } from "./GatFlex.vue?vue&type=template&id=08110960&scoped=true&"
import script from "./GatFlex.vue?vue&type=script&lang=js&"
export * from "./GatFlex.vue?vue&type=script&lang=js&"
import style0 from "./GatFlex.vue?vue&type=style&index=0&id=08110960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08110960",
  null
  
)

export default component.exports